import React from "react"
import PropTypes from "prop-types"
import { AnimatedArrow } from "containers"
import { withRadium, DetectCompact } from "higher-order-components"

/**
 * Bubble component
 * @param {Object} props - Component props
 * @param {String} props.content - Content for bubble.
 * @param {Boolean} props.show - Hide / show bubble.
 * @param {Number} props.bottom - Distance from bottom
 * @returns {ReactElement} React Component
 */
const Bubble = ({
  hideOnMobile = true,
  direction = "bottom",
  show = false,
  compact = false,
  content = "",
  desktopArrowLeft = null,
  desktopLeft = null,
  mobileArrowLeft = null,
  mobileLeft = null,
  bottom = 0
}) => (
  <div
    key={`bubble-${compact ? "0" : "1"}`}
    style={[
      hideOnMobile ? styles.base : styles.baseVisibleMobileAndDesktop,
      styles.pos(bottom),
      (!compact && desktopLeft && { left: desktopLeft + "px" }) || {},
      (compact && mobileLeft && { left: mobileLeft + "px" }) || {}
    ]}
    data-test="bubble">
    <div
      style={[
        !show && styles.hide,
        { position: "relative", display: "inline-block", transition: ".25s" }
      ]}>
      {direction === "bottom" && (
        <AnimatedArrow
          bgColor="#fff"
          borderColor="#ddd"
          leftPercent={(compact && mobileArrowLeft) || (!compact && desktopArrowLeft) || 50} />
      )}
      <span data-test="bubble-span" style={styles.span}>
        {content}
      </span>
      {direction === "top" && (
        <AnimatedArrow
          bgColor="#fff"
          borderColor="#ddd"
          leftPercent={(compact && mobileArrowLeft) || (!compact && desktopArrowLeft) || 50}
          down />
      )}
    </div>
  </div>
)

Bubble.propTypes = {
  content: PropTypes.node,
  show: PropTypes.bool,
  direction: PropTypes.string,
  bottom: PropTypes.number
}

export default withRadium(DetectCompact())(Bubble)

const styles = {
  pos: bottom => ({
    bottom: `${bottom}em`
  }),
  base: {
    display: "none",
    "@media (min-width: 768px)": {
      display: "block",
      position: "absolute",
      boxSizing: "border-box",
      width: "100vw",
      maxWidth: "300px",
      left: "50%",
      transform: "translate(-50%, 0)",
      zIndex: 20,
      pointerEvents: "none",
      textAlign: "center"
    }
  },
  baseVisibleMobileAndDesktop: {
    display: "block",
    position: "absolute",
    boxSizing: "border-box",
    width: "100vw",
    maxWidth: "300px",
    left: "40%",
    color: "#101010",
    transform: "translate(-50%, 0)",
    zIndex: 10,
    pointerEvents: "none",
    textAlign: "center"
  },
  span: {
    transition: ".4s",
    display: "inline-block",
    boxSizing: "border-box",
    background: "#FFF",
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
    fontWeight: 300,
    position: "relative",
    padding: "0.5em 1.2em",
    borderRadius: "5px"
  },
  hide: {
    opacity: 0,
    transform: "translateY(.5em)"
  }
}



// WEBPACK FOOTER //
// ./src/components/bubble/index.jsx